import React, { Component } from 'react';
import Graph from "react-graph-vis";
import { Link } from 'react-router-dom';

import  './DagRunViz.css';
import { withAuthorization } from '../Session';
import * as ROUTES from '../../constants/routes';

class DagRunViz extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      tasks: [],
      highlight: null
    };
    this.fetchData = this.fetchData.bind(this);
    this.setHighlight = this.setHighlight.bind(this);
  }

  setHighlight(event) {
    var { nodes } = event;
    if ( nodes.length === 1) {
      const node = nodes[0]
      this.setState({
        highlight: node
      });
    } else {
      this.setState({
        highlight: null
      });
    }
  }

  fetchData = () => {
    const flowId = this.props.flowId
    const dagId = this.props.dagId
    const runId = this.props.runId
    return this.props.firebase.taskInstances(flowId, runId, dagId).onSnapshot(
      querySnapshot => {
        var tasks = []
        querySnapshot.forEach(task => {
          tasks.push({
            id: task.id,
            project: task.data().project,
            upstream_task_ids: task.data().upstream_task_ids,
            state: task.data().state
          })
        });
        this.setState({
          tasks: tasks,
          loading: false,
        });
      }
    );
  }

  componentDidMount() {
    this.setState({ loading: true });
    this.unsubscribe =  this.fetchData();
  }

  componentWillUnmount() {
    this.unsubscribe();
  }


  render() {
    const flowId = this.props.flowId;
    const { tasks, loading, highlight } = this.state;

    if ( loading ) {
      return(
        <div>Loading..</div>
      )
    }

    if ( !loading && tasks.length === 0 ) {
      return(
        <div>No tasks found.</div>
      )
    }

    if ( !loading && tasks.length > 0 ) {

      var graph = {
        nodes: [],
        edges: []
      };

      this.state.tasks.forEach((task, i) => {
        graph.nodes.push({
          id: task.id,
          label: `<b>TASK</b>\n${task.id}\n<i>${task.state}</i>`,
          type: 'TASK',
          font: {
            face: 'Ubuntu Mono',
            color: '#66d9ef',
            multi: 'html'
          },
          color: {
            border: '#66d9ef',
            background: '#383E4A',
            opacity: 0,
            highlight: {
              border: '#66d9ef',
              background: '#282D36',
            }
          },
          borderWidth: 2
        })
        if ( task.upstream_task_ids ) {
          task.upstream_task_ids.forEach((fromTaskId, i) => {
            graph.edges.push({
              from: fromTaskId,
              to: task.id
            })
          })
        }
      })

      const options = {
        clickToUse: false,
        layout: {
          hierarchical: {
            sortMethod: 'directed',
            nodeSpacing: 200,
            direction: 'UD'
          },
        },
        nodes: {
          shape: 'box',
          widthConstraint: {
            minimum: 150,
            maximum: 150
          },
          heightConstraint: {
            minimum: 40
          }
        },
        edges: {
          color: "#ffffff"
        }
      };

      const events = {
        select: this.setHighlight
      };

      const highlightLink = ( highlight && !highlight.startsWith('__trigger__')
        ? <span>View tasks <Link to={`${ROUTES.FLOW}/${flowId}${ROUTES.DAG}/${highlight}`} >
            <b>{highlight}</b>
          </Link> details</span>
        : null
      )

      return (
        <div>
          <p>Click on a DAG to for details and DAG runs:</p>
          <div className='DagRunViz'>
            <Graph graph={graph} options={options}
                   events={events} style={{ height: "500px", width:"100%"}} />
          </div>
          <br/>
          {highlightLink}
        </div>

      );

    }


  }
}


const condition = authUser => !!authUser;

export default withAuthorization(condition)(DagRunViz);
